module.exports = __webpack_public_path__ + "img/qkw_deng_1.040f1936.gif";